// extracted by mini-css-extract-plugin
module.exports = {"fieldWithIcon":"FieldIcon_fieldWithIcon__tlTcL","iconWrapper":"FieldIcon_iconWrapper__VCDE7","icon":"FieldIcon_icon__1Rf8O"};